import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  stroke: "currentColor",
  strokeWidth: ".5",
  d: "M13.314 3.107c-2.81-2.81-7.397-2.81-10.207 0-2.81 2.81-2.81 7.398 0 10.207a7.154 7.154 0 0 0 5.104 2.114 7.21 7.21 0 0 0 4.536-1.598l2.938 2.938c.155.155.361.232.542.232.18 0 .386-.077.541-.232.31-.31.31-.799 0-1.083l-2.938-2.938a7.21 7.21 0 0 0 1.598-4.536 7.198 7.198 0 0 0-2.114-5.104zm-9.13 9.194a5.747 5.747 0 0 1 0-8.128A5.703 5.703 0 0 1 8.257 2.5c1.488 0 2.95.549 4.072 1.673C13.426 5.27 14 6.708 14 8.25c0 1.542-.6 2.98-1.67 4.077C11.258 13.425 9.796 14 8.256 14c-1.54-.026-3.003-.601-4.073-1.699z"
});
var Search = function Search(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, props), _ref);
};
export default Search;